import { render, staticRenderFns } from "./PurchaseInvoices.vue?vue&type=template&id=20b34f91&"
import script from "./PurchaseInvoices.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports